import { createIcon } from '../icon'
import MenuBackIcon from '../svg/MenuBackIcon'

export const MenuBackIconDefault = createIcon(MenuBackIcon)
